import { GameVars } from "./../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { BoardContainer } from "../BoardContainer";
import { Arrow } from "./Arrow";
import { GUI } from "./GUI";

export class StrikerSpeedSetter  {

    public static readonly MAX_RADIUS = 170;

    public activated: boolean;
    public r: number;
    public angle: number;

    public rAdversary: number;
    public angleAdversary: number;

    public circleGraphics: Phaser.GameObjects.Graphics;
    public dotsGraphics: Phaser.GameObjects.Graphics;
    public arrow: Arrow;

    private scene: Phaser.Scene;
    private isPlayer: boolean;
    private gui: GUI;

    constructor(scene: Phaser.Scene, isPlayer: boolean, gui: GUI) {
        
        this.scene = scene;
        this.isPlayer = isPlayer;
        this.gui = gui;
        this.activated = false;
    
        this.r = 0;
        this.angle = 0;

        this.rAdversary = 0;
        this.angleAdversary = 0;

        this.circleGraphics = new Phaser.GameObjects.Graphics(this.scene);
        this.dotsGraphics = new Phaser.GameObjects.Graphics(this.scene);

        const strikerY = GameVars.carromEngine.strikerY;
        
        if (isPlayer) {
            this.circleGraphics.y = strikerY * GameConstants.PHYS_SCALE;
            this.dotsGraphics.y = strikerY * GameConstants.PHYS_SCALE;
        } else {
            this.circleGraphics.y = -strikerY * GameConstants.PHYS_SCALE;
            this.dotsGraphics.y = -strikerY * GameConstants.PHYS_SCALE;
        }

        this.arrow = new Arrow(this.scene, isPlayer);
        this.deactivate();
    }

    public update(): void {

        if (!this.activated) {
            return;
        }

        const strikerPosition = BoardContainer.currentInstance.strikerPosition;
        const strikerRadius = GameVars.carromEngine.strikerRadius;

        if (this.r < strikerRadius * GameConstants.PHYS_SCALE * .95)  {
            this.circleGraphics.visible = false;
            this.dotsGraphics.visible = false;
            this.arrow.visible = false;
        } else {
            this.circleGraphics.visible = true;
            this.dotsGraphics.visible = true;
            this.arrow.visible = true;
        }

        if (GameVars.reversedBoard) {
            strikerPosition.x = -strikerPosition.x;
            strikerPosition.y = -strikerPosition.y;
        }
        
        strikerPosition.x = strikerPosition.x * GameConstants.PHYS_SCALE * BoardContainer.currentInstance.scaleX + GameConstants.GAME_WIDTH / 2;
        strikerPosition.y = strikerPosition.y * GameConstants.PHYS_SCALE * BoardContainer.currentInstance.scaleY + GameConstants.GAME_HEIGHT / 2;

        this.circleGraphics.x = (strikerPosition.x - GameConstants.GAME_WIDTH / 2) / BoardContainer.currentInstance.scaleX;
 
        this.circleGraphics.clear();

        if (GameVars.tutorialMode && GameVars.tutorialStage === TutorialStage.STAGE_3) {

            const tutorialCursor = this.gui.tutorialCursor;
            const strikerX = BoardContainer.currentInstance.striker.position.x;
            const strikerY = BoardContainer.currentInstance.striker.position.y;

            this.r = Math.sqrt((tutorialCursor.x - strikerX) * (tutorialCursor.x - strikerX) + (tutorialCursor.y - strikerY) * (tutorialCursor.y - strikerY));
        
        } else {

            if (this.isPlayer) {
                this.r = Phaser.Math.Distance.Between(this.scene.input.activePointer.x, this.scene.input.activePointer.y, strikerPosition.x, strikerPosition.y);
                this.r = this.r > StrikerSpeedSetter.MAX_RADIUS ? StrikerSpeedSetter.MAX_RADIUS : this.r;
            } else {
                this.r += (this.rAdversary - this.r) * .1;
            }
        }

        this.circleGraphics.fillStyle(0x555555, .15);
        this.circleGraphics.fillCircle(0, 0, this.r);

        // the dotted circle
        let angle = 0;
        const n = Math.round(this.r * .5 + 20);

        this.circleGraphics.fillStyle(0x333333);

        for (let i = 0; i < n; i ++) {

            const x = this.r * Math.cos(angle * Math.PI / 180);
            const y = this.r * Math.sin(angle * Math.PI / 180);

            angle += 360 / n;

            this.circleGraphics.fillPoint(x, y, 3);
        }

        // the arrow
        if (GameVars.tutorialMode) {
            this.angle = GameConstants.STRIKER_TUTORIAL_SHOT_ANGLE;
        } else {
            if (this.isPlayer) {
                this.angle = Math.atan2(strikerPosition.y - this.scene.input.activePointer.y, strikerPosition.x - this.scene.input.activePointer.x);
            } else {
                this.angle += (this.angleAdversary - this.angle) * .1;
            }
        }
       
        this.dotsGraphics.clear();
        this.dotsGraphics.x = this.circleGraphics.x;
       
        let rExt = 1.1 * this.r;
        let rInt = this.r - 5;
        const dr = 1.1 * StrikerSpeedSetter.MAX_RADIUS / 9;

        for (let i = 0; i < 9; i ++) {

            let x = rExt * Math.cos(this.angle);
            let y = rExt * Math.sin(this.angle);

            rExt += dr;

            let radius = 4;

            if (i === 7) {
                radius = 3;
            } else if ( i === 8) {
                radius = 2;
            }

            this.dotsGraphics.fillStyle(0x555555, .5);
            this.dotsGraphics.fillCircle(x + 2, y + 2, radius);

            this.dotsGraphics.fillStyle(0xFFFFFF);
            this.dotsGraphics.fillCircle(x, y, radius);

            const strikerRadius = GameVars.carromEngine.strikerRadius;

            if (rInt > 1.05 * strikerRadius * GameConstants.PHYS_SCALE) {

                x = rInt * Math.cos(Math.PI + this.angle);
                y = rInt * Math.sin(Math.PI + this.angle);

                this.dotsGraphics.fillStyle(0x333333, .65);
                this.dotsGraphics.fillCircle(x, y, 5);
    
                rInt -= dr;
            }
        }

        this.arrow.update(this.circleGraphics.x, this.angle, this.r);
    }

    public activate(): void {

        if (!GameVars.connection && !GameVars.tutorialMode) {
            return;
        }

        this.activated = true;
        
        this.r = 0;
        this.angle = 0;

        this.rAdversary = 0;
        this.angleAdversary = 0;
    }

    public deactivate(): void {
 
        this.circleGraphics.visible = false;
        this.dotsGraphics.visible = false;
        this.arrow.visible = false;
        this.activated = false;

        this.r = 0;
        this.angle = 0;

        this.rAdversary = 0;
        this.angleAdversary = 0;
    }
}
